<div>
	<div [hasPermission]="'root'">
		<label>Update interval ({{updateInterval * 0.5}}s)
			<input [(ngModel)]="updateInterval" min="1" type="number" />
		</label>
	</div>

	<bb-chart
		[datasets]="realtimeGraphDatasets"
		height="300"
		[bbChartSettings]="{
			xAxisLabels: xAxisLabels,
			maxLabelRotation: 0,
			xAxisAutoSkipPadding: 150
		}"
	></bb-chart>
</div>
